import { Activity_Types_Enum_Enum } from '@graphql/__generated__/graphql';
import type {
  ActivityType,
  PendingPlanActivity,
} from '@modules/_shared/components/feed/types';
import { isNullOrEmpty } from '@modules/_shared/utils/strings';

type Activity = {
  id: string;
  activity_type: Activity_Types_Enum_Enum;
  subject?: string | null;
  due_at?: string | null;
  start_date?: string | null;
  end_at?: string | null;
  created_at?: string | null;
  note?: string | null;
  assigned_to?: string | null;
  created_by?: string | null;
  lead_id?: string | null;
  lot_id?: string | null;
  buyer_lead_id?: string | null;
  user_id?: string | null;
  success?: boolean | null;
  done?: boolean | null;
  location?: string | null;
  activities_target_users: Array<{
    target_user_id?: string | null;
  }>;
};

type PlanActivityType = Extract<ActivityType, 'call' | 'visit' | 'task'>;

const ACTIVITY_TYPE_MAP: Partial<
  Record<Activity_Types_Enum_Enum, PlanActivityType>
> = {
  [Activity_Types_Enum_Enum.Call]: 'call',
  [Activity_Types_Enum_Enum.Visit]: 'visit',
  [Activity_Types_Enum_Enum.Task]: 'task',
};

export const groupActivitiesByType = (
  activities: Activity[],
): Partial<Record<PlanActivityType, PendingPlanActivity[]>> => {
  const grouped: Partial<Record<PlanActivityType, PendingPlanActivity[]>> = {};

  activities.forEach(activity => {
    const action = ACTIVITY_TYPE_MAP[activity.activity_type];
    if (!action) {
      return;
    }

    const pendingTask: PendingPlanActivity = {
      id: activity.id,
      subject: activity.subject ?? null,
      dueAt: activity.due_at ?? null,
      startDate: activity.start_date ?? null,
      endAt: activity.end_at ?? null,
      createdAt: activity.created_at ?? null,
      note: activity.note ?? null,
      assignedTo: activity.assigned_to ?? null,
      createdBy: activity.created_by ?? null,
      leadId: activity.lead_id ?? null,
      lotId: activity.lot_id ?? null,
      buyerLeadId: activity.buyer_lead_id ?? null,
      userId: activity.user_id ?? null,
      success: activity.success ?? undefined,
      done: activity.done ?? undefined,
      location: activity.location ?? null,
      targetUserIds: activity.activities_target_users
        .map(target => target.target_user_id)
        .filter((id): id is string => !isNullOrEmpty(id, true)),
    };

    grouped[action] ??= [];
    grouped[action].push(pendingTask);
  });

  return grouped;
};
